import { call, put, takeLatest } from "redux-saga/effects";
import chartTypes from "../types/chart";
import chart from "../actions/chart";
import axios from "../../services/axios";
// import role from "../actions/role";
// import auth from "../actions/auth";

function* radarChartData({ payload }) {
  try {
    const res = yield call(axios.request, {
      method: "GET",
      url: `/beska/getBehaviorReportData/${payload.sessionCode}/${payload.token}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (res.status === 0) {
      yield put(chart.radarChartDataSuccess(res.data));
    } else {
      yield put(chart.radarChartDataFailure(res));
    }
  } catch (err) {
    // yield put(chart.apiError(err));
    yield put(chart.radarChartDataFailure(err));
    console.log(err, "err");
  }
}

function* chartSaga() {
  yield takeLatest(chartTypes.RADAR_CHART_DATA, radarChartData);
}

export { chartSaga };
